(function () {
  const dataEl = document.getElementById("influencer-cookie-data")
  if (!dataEl) return

  let data
  try {
    data = JSON.parse(dataEl.textContent)
  } catch {
    return
  }

  if (data.discountCode == null || data.discount == null) return

  const days = 2
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
  document.cookie = "influencer=" + JSON.stringify(data) + "; expires=" + expires + "; path=/"

  // Auto-apply discount code to cart session via Shopify discount endpoint
  fetch("/discount/" + encodeURIComponent(data.discountCode), {
    method: "GET",
    credentials: "same-origin"
  }).catch(function () {
    // Silently ignore errors - discount can still be applied manually
  })

  window.dispatchEvent(new CustomEvent("influencer-cookie-set"))
})()